import classNames from 'classnames';
import { getPremiumEtfTickers } from 'helpers';
import { ReactNode } from 'react';
import styles from './etf.module.scss';

const premiumEtfTickers = getPremiumEtfTickers();

export interface EtfLabelProps {
	ticker: string;
	suffix?: string | ReactNode;
	prefix?: string | ReactNode;
	allowNavigation?: boolean;
}
export const EtfLabel = (props: EtfLabelProps) => {
	const isPremium = premiumEtfTickers.indexOf(props.ticker) !== -1;

	function renderContent() {
		return (
			<>
				{
					props.prefix
						? <span className={styles.prefix}>{props.prefix}</span> 
						: null
				}
				<span className={classNames(styles.container, { [styles.premium]: isPremium })}>{props.ticker}</span>
				{
					props.suffix
						? <span className={styles.suffix}>{props.suffix}</span> 
						: null
				}
			</>
		);
	}

	if (props.allowNavigation) {
		return (<a href={`/etf/${props.ticker}/overview`}>{renderContent()}</a>);
	}
	else {
		return (<span>{renderContent()}</span>);
	}
	
}